export default __webpack_public_path__ + "static/media/postexpress.c54599d7.png";